import Projects from "../components/Projects";

function ProjectsPage() {
    return (
        <Projects title="my projects" showLink={false}/>
    )
}

export default ProjectsPage;
